<template>
    <div>
        <my-search @search="searchHandler" v-model="pgData" >
            <el-form-item slot="time">
                <el-input type="text" style="width:200px" v-model="pgData.title" placeholder="请输入标段名称/标段编号" clearable></el-input>

            </el-form-item>
            <el-form-item slot="title">
                <el-input type="text" v-model="pgData.zbproname" placeholder="请输入项目名称" clearable></el-input>
            </el-form-item>
            <el-form-item slot="title">
                <my-select
                    placeholder="选择评价主体"
                    v-model="pgData.type"
                    :data="[
                        {key: '', value: '全部'}, 
                        {key: '1', value: '招标文件编制部门'}, 
                        {key: '2', value: '中标单位'},
                    ]"
                ></my-select>
            </el-form-item>
            <el-form-item slot="title">
                <my-select
                    placeholder="评价状态"
                    v-model="pgData.shbj"
                    :data="[
                        {key: '', value: '全部'}, 
                        {key: '1', value: '已评价'}, 
                        {key: '0', value: '未评价'},
                    ]"
                ></my-select>
            </el-form-item>
             <el-form-item slot="title">
                <el-input type="text" v-model="pgData.typename" placeholder="请输入评价主体名称" clearable></el-input>
            </el-form-item>
             <el-form-item slot="title">
               <my-select
                    placeholder="请选择评分开始范围"
                    v-model="pgData.startscore"
                    :data="[
                        {key: '1', value: '1'}, 
                        {key: '2', value: '2'},
                        {key: '3', value: '3'},
                        {key: '4', value: '4'},
                        {key: '5', value: '5'},
                    ]"
                ></my-select>
                至
                <my-select
                    placeholder="请选择评分结束范围"
                    v-model="pgData.endscore"
                    :data="[
                        {key: '1', value: '1'}, 
                        {key: '2', value: '2'},
                        {key: '3', value: '3'},
                        {key: '4', value: '4'},
                        {key: '5', value: '5'},
                    ]"
                ></my-select>
            </el-form-item>
            <template slot="btn">
                <my-btn type="new" @click="exportExcel()">导出Excel</my-btn>
            </template>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="项目名称" prop="zbproname" min-width="220" fixed="left"></el-table-column>
            <el-table-column label="标段名称" prop="bdname" min-width="220" fixed="left"></el-table-column>
            <el-table-column label="标段编码" prop="bdcode" min-width="160"></el-table-column>
            <el-table-column label="评价主体" prop="type" min-width="160"></el-table-column>
            <el-table-column label="评价主体名称" prop="typename" min-width="160"></el-table-column>
            <el-table-column label="状态" prop="bdcode" min-width="160">
                <template slot-scope="scope">
                    <my-tag type="info" v-if="scope.row.jdscore===null">未评价</my-tag>
                    <my-tag type="success" v-else>已评价</my-tag>
                </template>
            </el-table-column>
            <el-table-column label="评分" prop="jdscore" min-width="160" >
                 <template slot-scope="scope">
                    <div v-if="scope.row.jdscore===null">
                       -
                    </div>
                    <div v-else>
                       {{scope.row.jdscore}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="标签内容" prop="jdcontent" min-width="160"></el-table-column>
            <el-table-column label="其他内容" prop="jdcontentdetail" min-width="160"></el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/servicecommon/pj/getPjlist.json`">
        </my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'

export default {
    mixins: [LIST_PAGE_MIXIN,DIALOG_LIST_PAGE_MIXIN],

    data() {
        return{
            pgData:{
                bdcode:'',
                sortname:'bdaddtime',
                sortorder: 'desc',
                endscore:'',
                startscore:'',
                type:'',
                title:'',
                zbproname:'',
                typename:'',
                shbj:''




            },
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        searchHandler() {
            console.log(this.pgData.endscore)
            if(this.pgData.startscore!==''&&this.pgData.endscore!==''&&this.pgData.endscore<this.pgData.startscore) {
                      ShowMsg('评分结束范围不能小于评分开始范围')
                        return
                    }
                    if(this.pgData.startscore==''&&this.pgData.endscore!=='') {
                      console.log(1)
                      ShowMsg('请选择评分开始范围')
                        // $vue.$message({
                        //     type: 'info',
                        //     message: '请选择评分开始范围',
                        // });
                        return
                    }
                    if(this.pgData.endscore==''&&this.pgData.startscore!=='') {
                       ShowMsg('请选择评分结束范围')
                        return
                    }
                    this.$refs.page.queryData(1, this.pgData.pagesize)
        },
        exportExcel() {
            console.log(`${this.getGetters('bidUrl')}/servicecommon/pj/qdexcelexport?type=`+this.pgData.type+'&title='+this.pgData.title+'&zbproname='+this.pgData.zbproname+'&typename='+this.pgData.typename+'&shbj='+this.pgData.shbj+'&sortname=createdtime&sortorder=desc')
            window.location.href=`${this.getGetters('bidUrl')}/servicecommon/pj/qdexcelexport?type=`+this.pgData.type+'&title='+this.pgData.title+'&zbproname='+this.pgData.zbproname+'&typename='+this.pgData.typename+'&shbj='+this.pgData.shbj+'&startscore='+this.pgData.startscore+'&endscore='+
            this.pgData.endscore
        }
    },
    created() {
       
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
.v-modal {
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000000;
}
</style>
